import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M14,10 C14,10.552 13.552,11 13,11 L11,11 L11,13 C11,13.552 10.552,14 10,14 C9.448,14 9,13.552 9,13 L9,11 L7,11 C6.448,11 6,10.552 6,10 C6,9.448 6.448,9 7,9 L9,9 L9,7 C9,6.448 9.448,6 10,6 C10.552,6 11,6.448 11,7 L11,9 L13,9 C13.552,9 14,9.448 14,10 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0"
      id="path-1"
    />
  </svg>
);
